let $ = jQuery;
$ = require('../plugins/readmore');
let breakpoints = require('../utilities/breakpoints');

class SectionAboutMe {

  constructor() {

    this.$readmore = $('.profile-section--about .profile-section__readmore');

    this.options = {
      speed: 75,
      lessLink: '<a href="#">Read less</a>'
    };

    $(window).resize(() => this.handleState()).trigger('resize');

  }

  handleState() {

    if(
      breakpoints.current === 'small' || breakpoints.current === 'medium'
    ) {

      var attr = this.$readmore.attr('data-readmore');

      if (!(typeof attr !== typeof undefined && attr !== false)) {
        this.$readmore.readmore(this.options);
      }

    } else {
      this.$readmore.readmore('destroy');
    }
  }

}

module.exports = {
  attach: function (context, settings) {
    new SectionAboutMe();
  }
};
